import { useEffect } from "react";
import { useMap } from "react-leaflet";
import { LocateControl as LCtl } from "leaflet.locatecontrol";
import "leaflet.locatecontrol/dist/L.Control.Locate.min.css";

function LocateControl({ options, setCoords }) {
  const map = useMap();

  useEffect(() => {
    if (!map) return;
    const lc = new LCtl(options);
    lc.addTo(map);

    const onLocationFound = (e) => {
      lc.stop();
      setCoords({
        latitude: e.latlng.lat,
        longitude: e.latlng.lng + (1 + Math.random()) * 1e-6
      });
    };
    map.on("locationfound", onLocationFound);

    lc.stop();

    return () => {
      map.off("locationfound", onLocationFound);
      map.removeControl(lc);
    };
  }, [map, options, setCoords]);

  return null;
}

export default LocateControl;
